module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-8e6c5b78.png";